import axios from 'axios'
import qs from 'qs'
localStorage.url = 'https://site.musicwow.com'

//创建axios的一个实例 baseURL: 'https://site.musicwow.com/',
var instance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
})
//------------------- 一、请求拦截器 忽略
instance.interceptors.request.use(function (config) {
    if (config.requestBaseUrl === 'act') { // test2API
        config.baseURL = process.env.VUE_APP_ACT_API
    }
    if (config.requestBaseUrl === 'con') { // test2API后期整合同一个appv2域名，时间问题先修改成这样
        config.baseURL = process.env.VUE_APP_CONT_API;
    }
    if (config.requestBaseUrl === 'cont') { // test2API
        if(!!localStorage.getItem('contoken')){
            config.headers =  {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-DEVICE-TYPE':4,
                'X-APP-NAME':'musicwow',
                'YW-TOKEN':localStorage.getItem('contoken')
            }
        }else{
            config.headers =  {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-DEVICE-TYPE':4,
                'X-APP-NAME':'musicwow',
            }
        }
        config.baseURL = process.env.VUE_APP_CONT_API;
        console.log(config)
    }
    return config;
}, function (error) {
    // 对请求错误做些什么

    return Promise.reject(error);
});

//----------------- 二、响应拦截器 忽略
instance.interceptors.response.use(function (response) {

    return response.data;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});


export default function (method, url, data = null, requestBaseUrl = '') {
    method = method.toLowerCase();
    instance.defaults.requestBaseUrl = requestBaseUrl;
    // console.log(instance.defaults.headers)
    if (method == 'post') {
        return instance.post(url, qs.stringify(data))
    } else if (method == 'get') {
        return instance.get(url, { params: data })
    } else if (method == 'delete') {
        return instance.delete(url, { params: data })
    } else if (method == 'put') {
        return instance.put(url, data)
    } else {
        console.error('未知的method' + method)
        return false
    }

}